import { render } from "./FrisbuySrStory.vue?vue&type=template&id=469d5ae2&scoped=true"
import script from "./FrisbuySrStory.vue?vue&type=script&lang=js"
export * from "./FrisbuySrStory.vue?vue&type=script&lang=js"

import "./FrisbuySrStory.vue?vue&type=style&index=0&id=469d5ae2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-469d5ae2"]])

export default __exports__